import Timer from '@wetransfer/concorde-timer';

import { TransferAPI } from '../services/api/transfer';
import { ActionHelper } from '../../core-bundle/store/actions-generator';
import { TransferConfig } from '../config/transfer-config';

import Action from '@app/action';

export const TransferUploadActionTypes = ActionHelper.generateTypes([
  'RESET_UPLOAD_PROGRESS',
  'UPDATE_UPLOAD_TIME',
  'SET_LAST_UPDATE',
  'UPDATE_UPLOAD_PROGRESS',
]);

export const TransferUploadActions = ActionHelper.generateActions({
  resetUploadProgress: [TransferUploadActionTypes.RESET_UPLOAD_PROGRESS],
  updateUploadTime: [
    TransferUploadActionTypes.UPDATE_UPLOAD_TIME,
    'bytesSentSoFar',
    'transferTotalSize',
  ],
  setLastUpdate: [TransferUploadActionTypes.SET_LAST_UPDATE],
  updateUploadProgress: [
    TransferUploadActionTypes.UPDATE_UPLOAD_PROGRESS,
    'bytesSentSoFar',
    'transferTotalSize',
    'transferUploadStartedAt',
  ],

  stopUploadProgress,
  pauseUploadProgress,
  startUploadProgress,
  estimateUploadTime,
  calculateUploadProgress,
  verifyPassword,
});

let remainingTimer;
let progressTimer;

function estimateUploadTime(transferFiles, transferTotalSize) {
  return (dispatch) => {
    dispatch(TransferUploadActions.setLastUpdate());

    if (remainingTimer) {
      remainingTimer.stop();
    }

    remainingTimer = new Timer(
      TransferConfig.upload.remainingTimeInterval,
      () => {
        // We use the transfer files inside the action as the files hold a
        // reference to the bytes sent, and we need to calculate the
        // whole amount of bytes sent every time this action runs.
        const bytesSentSoFar = transferFiles.reduce(
          (count, file) => count + file.bytesSent,
          0
        );

        dispatch(
          TransferUploadActions.updateUploadTime(
            bytesSentSoFar,
            transferTotalSize
          )
        );

        dispatch(
          TransferUploadActions.estimateUploadTime(
            transferFiles,
            transferTotalSize
          )
        );
      }
    );
  };
}

function stopUploadProgress() {
  return (dispatch) => {
    dispatch(TransferUploadActions.pauseUploadProgress());
    dispatch(TransferUploadActions.resetUploadProgress());
  };
}

function calculateUploadProgress(
  transferFiles,
  transferTotalSize,
  transferUploadStartedAt
) {
  return (dispatch) => {
    // We use the transfer files inside the action as the files hold a
    // reference to the bytes sent, and we need to calculate the
    // whole amount of bytes sent every time this action runs.
    const bytesSentSoFar = transferFiles.reduce(
      (count, file) => count + file.bytesSent,
      0
    );

    dispatch(
      TransferUploadActions.updateUploadProgress(
        bytesSentSoFar,
        transferTotalSize,
        transferUploadStartedAt
      )
    );

    if (progressTimer) {
      progressTimer.stop();
    }

    progressTimer = new Timer(TransferConfig.upload.progressInterval, () => {
      dispatch(
        TransferUploadActions.calculateUploadProgress(
          transferFiles,
          transferTotalSize,
          transferUploadStartedAt
        )
      );
    });
  };
}

function startUploadProgress(
  transferFiles,
  transferTotalSize,
  transferUploadStartedAt
) {
  return (dispatch) => {
    dispatch(
      TransferUploadActions.estimateUploadTime(transferFiles, transferTotalSize)
    );
    dispatch(
      TransferUploadActions.calculateUploadProgress(
        transferFiles,
        transferTotalSize,
        transferUploadStartedAt
      )
    );
  };
}

function pauseUploadProgress() {
  return () => {
    if (remainingTimer) {
      remainingTimer.stop();
      remainingTimer = null;
    }

    if (progressTimer) {
      progressTimer.stop();
      progressTimer = null;
    }
  };
}

function verifyPassword(transferId, secret, recipient, password) {
  return async (dispatch) => {
    try {
      const fetchedTransfer = await TransferAPI.fetchTransfer(
        transferId,
        secret,
        recipient,
        password,
        false
      );

      dispatch(Action.Transfer.verifiedPassword(password));
      dispatch(Action.Transfer.buildTransfer(fetchedTransfer, password));
      dispatch(Action.Notification.clearTransfer());
    } catch (error) {
      dispatch(Action.Notification.pushTransfer({ text: 'InvalidPassword' }));
    }
  };
}
